/**
 * 激活码相关工具函数
 */

// 写死的激活码
const VALID_ACTIVATION_CODE = 'Y!lxKi8QgkFVHCjB'

/**
 * 检查是否已激活
 * @returns {boolean} 是否已激活
 */
export function isActivated() {
  try {
    const savedCode = localStorage.getItem('rpi_activation_code')
    return savedCode === VALID_ACTIVATION_CODE
  } catch (error) {
    console.error('检查激活状态失败:', error)
    return false
  }
}

/**
 * 保存激活码到缓存
 * @param {string} code 激活码
 * @returns {boolean} 是否保存成功
 */
export function saveActivationCode(code) {
  try {
    if (code === VALID_ACTIVATION_CODE) {
      localStorage.setItem('rpi_activation_code', code)
      localStorage.setItem('rpi_activation_timestamp', new Date().toISOString())
      return true
    }
    return false
  } catch (error) {
    console.error('保存激活码失败:', error)
    return false
  }
}

/**
 * 验证激活码
 * @param {string} code 要验证的激活码
 * @returns {boolean} 是否有效
 */
export function validateActivationCode(code) {
  return code === VALID_ACTIVATION_CODE
}

/**
 * 清除激活码缓存
 */
export function clearActivationCode() {
  try {
    localStorage.removeItem('rpi_activation_code')
    localStorage.removeItem('rpi_activation_timestamp')
  } catch (error) {
    console.error('清除激活码失败:', error)
  }
}

/**
 * 获取激活时间
 * @returns {string|null} 激活时间字符串或null
 */
export function getActivationTime() {
  try {
    return localStorage.getItem('rpi_activation_timestamp')
  } catch (error) {
    console.error('获取激活时间失败:', error)
    return null
  }
}
